import React, { ReactNode } from "react";
import { Popable } from "react-native-popable";

import { Box } from "../../../../primitive";

type TooltipProps = {
  direction?: "top" | "bottom" | "left" | "right";
  size?: "small" | "large";
  trigger: ReactNode;
  content: ReactNode;
  backgroundColor?: string;
  disable?: boolean;
};

export const Tooltip = ({
  direction = "top",
  size = "small",
  trigger,
  content,
  backgroundColor = undefined,
  disable,
}: TooltipProps) => {
  return (
    <Popable
      action="hover"
      style={{
        width: size === "large" ? 200 : "auto",
        opacity: disable ? 0 : 1,
      }}
      position={direction}
      backgroundColor={backgroundColor}
      content={
        <Box
          paddingHorizontal={3}
          paddingVertical={2}
          backgroundColor="surface-inverse"
          flex={1}
        >
          {content}
        </Box>
      }
    >
      {trigger}
    </Popable>
  );
};
